module.exports = __webpack_public_path__ + "img/20200515_160248.53390fa8.jpg";